import { render } from "./BulletFrame.vue?vue&type=template&id=30f67a5e&scoped=true"
import script from "./BulletFrame.vue?vue&type=script&lang=js"
export * from "./BulletFrame.vue?vue&type=script&lang=js"

import "./BulletFrame.vue?vue&type=style&index=0&id=30f67a5e&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f67a5e"]])

export default __exports__